import { useMobileMenu } from "@lib/context/mobile-menu-context";
import clsx from "clsx";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useState } from "react";
import { colors, PAGES } from "@lib/constants";
import X from "@modules/common/icons/x";
import ChevronDown from "@modules/common/icons/chevron-down";
import CurvyButton from "@modules/common/components/curvy-button";
import { useRouter } from "next/router";
import PrepitLogo from "@modules/common/icons/prepit-logo";
import Calendar from "@modules/common/icons/calendar";
import LanguageSwitcher from "@modules/common/components/language-switcher";
import { useTranslation } from "@i18n";

const MainMenu = () => {
  const pathname = usePathname();
  const { close } = useMobileMenu();
  const router = useRouter();
  const { t } = useTranslation();
  const [languageOpen, setLanguageOpen] = useState(false);

  return (
    <div className="flex flex-col flex-1">
      <div className="flex items-center justify-between w-full px-6 py-4 border-b border-gray-200">
        <div className="flex-1 basis-0"></div>
        <div>
          <h2 className="uppercase text-xl-semi">
            <PrepitLogo color={colors.primary} width={100} height={30} />
          </h2>
        </div>
        <div className="flex justify-end flex-1 basis-0">
          <button onClick={close}>
            <X size={20} />
          </button>
        </div>
      </div>

      <div className="flex flex-col justify-between flex-1 p-6 space-y-6">
        <div className="flex flex-col flex-1 text-gray-900 text-large-regular">
          <ul className="flex flex-col gap-y-2 ">
            {PAGES.filter((p) => p.path !== "/contact").map((page, index) => {
              return (
                <li
                  className={clsx("p-4 bg-gray-50", {
                    "text-large-semi": pathname === page.path,
                    "text-large-regular": pathname !== page.path,
                  })}
                  key={index}
                >
                  <Link href={page.path} area-label={t.nav[page.key]}>
                    <button
                      className="flex items-center justify-between w-full"
                      onClick={close}
                    >
                      <span className="sr-only">{t.nav[page.key]}</span>
                      <span>{t.nav[page.key]}</span>
                    </button>
                  </Link>
                </li>
              );
            })}

            {/* Language collapsible — same row style as Home / About Us. */}
            <li className="p-4 bg-gray-50 flex flex-col">
              <button
                type="button"
                onClick={() => setLanguageOpen((prev) => !prev)}
                aria-expanded={languageOpen}
                className="flex items-center justify-between w-full text-large-regular"
              >
                <span>{t.nav.language}</span>
                <ChevronDown
                  size={16}
                  color="currentColor"
                  className={clsx("transition-transform duration-200", {
                    "rotate-180": languageOpen,
                  })}
                />
              </button>
              {languageOpen && (
                <div className="mt-3 flex justify-center">
                  <LanguageSwitcher />
                </div>
              )}
            </li>

            <hr className="m-4"></hr>

            <p className="text-center text-darkGreen pb-3">
              {t.nav.wantToGetInTouch}{" "}
              <span className="font-semibold">{t.nav.inTouch}</span>
            </p>

            <CurvyButton
              onClick={() => {
                router.push("/#contact");
                close();
              }}
              className="!bg-lightPrimary !text-darkGreen !px-6 !py-2 rounded-full justify-center"
            >
              <Calendar size={15} />
              {t.nav.bookDemo}
            </CurvyButton>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MainMenu;
